import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type {
  RentPaymentProcessingFeesSettings,
  RentPaymentProcessingFeesSettingsCompanyPortalTypedSettingsWithOverridesDocument,
  SettingsLevel,
} from '~/swagger/settings/Api';

export type Level = `${SettingsLevel}`;

const SETTINGS_BASE_URL = `${envConfig.service.settings}/company-portal/settings`;
const RENT_PAYMENT_SETTINGS_URL = `${SETTINGS_BASE_URL}/rentpaymentprocessingfees`;

export class RentPaymentProcessingFeesSettingsRepository extends BaseRestRepository {
  public async getAllRentPaymentProcessingFees(): Promise<RentPaymentProcessingFeesSettingsCompanyPortalTypedSettingsWithOverridesDocument> {
    const url = `${RENT_PAYMENT_SETTINGS_URL}/with-overrides`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getLevelRentPaymentProcessingFees(level: Level, levelId: string): Promise<RentPaymentProcessingFeesSettings> {
    const url = `${RENT_PAYMENT_SETTINGS_URL}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async deleteLevelRentPaymentProcessingFees(level: Level, levelId: string): Promise<void> {
    const url = `${RENT_PAYMENT_SETTINGS_URL}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url, { method: 'DELETE' });
    return this.getJsonResponse(response);
  }

  public async createLevelRentPaymentProcessingFees(
    level: Level,
    levelId: string,
    payload: RentPaymentProcessingFeesSettings
  ): Promise<RentPaymentProcessingFeesSettings> {
    const url = RENT_PAYMENT_SETTINGS_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload, targets: [{ level, levelId }] }),
    });
    return this.getJsonResponse(response);
  }

  public async getRentPaymentProcessingFees(): Promise<RentPaymentProcessingFeesSettings> {
    const url = `${RENT_PAYMENT_SETTINGS_URL}/company`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async deleteRentPaymentProcessingFees(): Promise<void> {
    return undefined;
  }

  public async createRentPaymentProcessingFees(payload: RentPaymentProcessingFeesSettings): Promise<RentPaymentProcessingFeesSettings> {
    const url = `${RENT_PAYMENT_SETTINGS_URL}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  }
}
